export default {"src":"/_next/static/media/outer-3.51813d4d.svg","height":65,"width":65,"blurWidth":0,"blurHeight":0};